import React from 'react'

export function IdentityManualCheckItem({todo, onCheckHandler}) {
    
    const handler = async (event) => {
        const {checked} = event.target;
        await onCheckHandler(todo.uuid, checked)
    }
    
    const {uuid, done, text} = todo

    return (
        <>
            <div className='identity-checklist-row'>
                <input 
                    id={uuid}
                    type='checkbox' 
                    onChange={handler}
                    checked={done}
                ></input>
                <label htmlFor={uuid}>{text}</label>
            </div> 
        </>
    )
}
